<div class="wrapper">
  <app-multi-labor-equipment-details
    [initialEntry]="data?.laborDetails || null"
    entityType="labor"
  />
  <app-actions-section
    [disableAddMenu]="true"
    class="actions-section w-[455px]"
  />
</div>
